import React, { useRef, useState, useEffect } from "react";
import FormField from "../../forms/form-field";
import FormSelect from "../../forms/form-select";
import Tooltip from "../../tooltip/tooltip";
import { Button } from "react-bootstrap";
import BaseModal from "../../modals/base-modal";
import useLocationStore from "../config/use-location-store";
import { instanceMob } from "../../../utils/utils";

const SaleStepProducts = ({ show, onClose, onBack, onNext }) => {
    const formRef = useRef(null);
    const [userData, setUserData] = useState(null);
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [cart, setCart] = useState([]);
    const [formValues, setFormValues] = useState({
        productId: "",
        quantity: "",
        price_unity: "",
    });

    const selectedLocation = useLocationStore((state) => state.selectedLocation);

    const fetchProducts = () => {
        setIsLoading(true);
        instanceMob
            .get("admin/accounting/products/list", {
                params: { location_id: selectedLocation.id },
            })
            .then((res) => {
                if (Array.isArray(res.data) && res.data.length > 0) {
                    setProducts(res.data);
                } else {
                    setProducts([]);
                }
            })
            .catch((err) => console.error("Error cargando productos:", err))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        const storedUser = {
            email: localStorage.getItem("email"),
            first_name: localStorage.getItem("first_name"),
            last_name: localStorage.getItem("last_name"),
            id: localStorage.getItem("id"),
        };
        setUserData(storedUser);
    }, []);

    const handleProductsChange = (productId) => {
        const product = products.find((p) => p.product_id === productId);
        setFormValues({
            productId,
            price_unity: product ? product.sale_price_per_unit : 0,
            quantity: 1,
        });
    };

    const handleQuantityChange = (e) => {
        setFormValues((prev) => ({ ...prev, quantity: Number(e.target.value) }));
    };

    const addProductToCart = () => {
        if (!formValues.productId) return;

        const product = products.find((p) => p.product_id === formValues.productId);
        if (!product) return;

        setCart((prev) => {
            const existing = prev.find((item) => item.product_id === product.product_id);
            if (existing) {
                return prev.map((item) =>
                    item.product_id === product.product_id
                        ? { ...item, quantity: item.quantity + formValues.quantity }
                        : item
                );
            }
            return [...prev, { ...product, quantity: formValues.quantity }];
        });

        setFormValues({ productId: "", quantity: "", price_unity: "" });
    };

    const handleContinue = () => {
        let updatedCart = [...cart];

        if (formValues.productId) {
            const product = products.find((p) => p.product_id === formValues.productId);
            if (product) {
                const existing = updatedCart.find((item) => item.product_id === product.product_id);
                if (existing) {
                    updatedCart = updatedCart.map((item) =>
                        item.product_id === product.product_id
                            ? { ...item, quantity: item.quantity + formValues.quantity }
                            : item
                    );
                } else {
                    updatedCart = [...updatedCart, { ...product, quantity: formValues.quantity }];
                }
            }
        }

        setCart(updatedCart);

        onNext(updatedCart);
    };


    const handleRemoveProduct = (id) => {
        setCart((prev) => prev.filter((item) => item.product_id !== id));
    };

    const handleIncrease = (id) => {
        setCart((prev) =>
            prev.map((item) =>
                item.product_id === id ? { ...item, quantity: item.quantity + 1 } : item
            )
        );
    };

    const handleDecrease = (id) => {
        setCart((prev) =>
            prev.map((item) =>
                item.product_id === id && item.quantity > 1
                    ? { ...item, quantity: item.quantity - 1 }
                    : item
            )
        );
    };

    const formFields = [
        {
            Component: FormSelect,
            label: "Agregar Producto",
            name: "products",
            type: "select",
            placeholder: "Seleccione los productos",
            required: true,
            isLoading,
            options: products.map((p) => ({ value: p.product_id, label: p.name })),
            searchable: true,
            multiple: false,
            value: formValues.productId,
            onChange: ({ target }) => handleProductsChange(target.value),
            tooltip:
                "Nombre del artículo seleccionado en el inventario. Puedes buscarlo escribiendo parte del nombre o seleccionándolo de la lista desplegable.",
            badge: cart.length >= 1 ? `#${cart.length + 1}` : undefined,
        },
        {
            Component: FormField,
            label: "Cantidad",
            name: "quantity",
            type: "number",
            value: formValues.quantity,
            onChange: handleQuantityChange,
            placeholder: "Ingresa un valor",
            isLoading,
        },
        {
            Component: FormField,
            label: "Precio por unidad",
            name: "price_unity",
            type: "number",
            value: formValues.price_unity,
            readOnly: true,
            placeholder: "automático",
            isLoading,
        },
    ];

    useEffect(() => {
        fetchProducts();
    }, []);

    return (
        <BaseModal
            show={show}
            onClose={onClose}
            title="Registro de venta"
            onSave={() => formRef.current.requestSubmit()}
            saveText="Continuar"
            footer={false}
            size="lg"
            backable={true}
            onBack={onBack}
        >
            <form ref={formRef} className="d-flex flex-column gap-3">
                {formFields.map((field, index) => {
                    const FieldComponent =
                        typeof field.Component === "string"
                            ? React.createElement(field.Component, { ...field })
                            : <field.Component {...field} />;
                    return field.tooltip ? (
                        <Tooltip
                            key={index}
                            title={field.label}
                            description={field.tooltip}
                            position="right"
                            variant="rich"
                        >
                            {FieldComponent}
                        </Tooltip>
                    ) : (
                        <React.Fragment key={index}>{FieldComponent}</React.Fragment>
                    );
                })}
                <input type="hidden" name="userId" value={userData?.id || ""} />
                <input type="hidden" name="locationId" value={selectedLocation?.id || ""} />
            </form>

            <div className="d-flex justify-content-center align-items-center gap-2 mt-3 border-top pt-3">
                <Button
                    className="base-modal-done-button"
                    variant="secondary"
                    disabled={!formValues.productId && !cart.length}
                    onClick={handleContinue}
                >
                    Continuar
                </Button>
                <Button
                    className="base-modal-info-button"
                    variant="primary"
                    onClick={addProductToCart}
                >
                    Agregar otro producto
                </Button>
            </div>

            {cart.length > 0 && (
                <div className="mt-3 border-top pt-3">
                    <div className="sale-modal-summary-products p-2">
                        <div className="sale-modal-summary-products-header d-flex flex-row gap-1 border-bottom">
                            <label className="sale-modal-summary-products-header-title"> Carrito </label>
                        </div>

                        <div className="sale-modal-summary-products-table p-2">
                            {cart.map((item) => (
                                <div
                                    key={item.product_id}
                                    className="d-flex align-items-center justify-content-between py-2 border-bottom"
                                >
                                    <div className="d-flex align-items-center gap-2">
                                        <svg
                                            onClick={() => handleRemoveProduct(item.product_id)}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM9.63086 8.22363C9.23809 7.90369 8.65894 7.927 8.29297 8.29297C7.927 8.65894 7.90369 9.23809 8.22363 9.63086L8.29297 9.70703L10.5859 12L8.29297 14.293C7.90244 14.6835 7.90244 15.3165 8.29297 15.707C8.68349 16.0976 9.31651 16.0976 9.70703 15.707L12 13.4141L14.293 15.707C14.6835 16.0976 15.3165 16.0976 15.707 15.707C16.0976 15.3165 16.0976 14.6835 15.707 14.293L13.4141 12L15.707 9.70703L15.7764 9.63086C16.0963 9.23809 16.073 8.65894 15.707 8.29297C15.3411 7.927 14.7619 7.90369 14.3691 8.22363L14.293 8.29297L12 10.5859L9.70703 8.29297L9.63086 8.22363Z"
                                                fill="#FF644B"
                                            />
                                        </svg>
                                        <span className="sale-modal-summary-products-table-label">{item.name}</span>
                                    </div>
                                    <div className="d-flex align-items-center gap-4">
                                        <span className="sale-modal-summary-products-table-label">
                                            ${(item.sale_price_per_unit * item.quantity).toLocaleString()}
                                        </span>
                                        <div className="d-flex align-items-center gap-2 bg-white border border-1 rounded px-2">
                                            <button className="btn btn-sm border-0" onClick={() => handleDecrease(item.product_id)}>-</button>
                                            <span className="sale-modal-summary-products-table-label">{item.quantity}</span>
                                            <button className="btn btn-sm border-0" onClick={() => handleIncrease(item.product_id)}>+</button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </BaseModal>
    );
};

export default SaleStepProducts;
